import { Pipe, PipeTransform } from '@angular/core';
import { NamePerson } from '../models';
import { getFullname } from '../public-api';



@Pipe({
  name: 'fullname',
  standalone: true
})
export class FullnamePipe implements PipeTransform {

  transform(name: NamePerson): string {
    return getFullname(name);
  }
}
